import React from 'react';
import { Grid, Typography } from '@mui/material';
import { getNumberComma } from '../../../utils/numberUtils';

const CostSummary = ({
  project,
  costsVat,
  totalPurchase,
  totalSales,
  totalProfit,
  totalMargin,
}) => {
    const handleToggleDesc = () => {
     console.log('aaa');
  };
  
  return (
    <Grid
      container
      direction="row"
      justifyContent="flex-start"
      alignItems="center"
    >
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div" onClick={handleToggleDesc}>
          총 매출액
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {project?.totalSales
            ? getNumberComma(project.totalSales)
            : getNumberComma(totalSales)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          총 매입액
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {project?.totalPurchase
            ? getNumberComma(project.totalPurchase)
            : getNumberComma(totalPurchase)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          총 매출이익
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {project?.totalProfit
            ? getNumberComma(project?.totalProfit)
            : getNumberComma(totalProfit)}{' '}
          원
        </Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="subtitle2" component="div">
          이익율
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography variant="body2" component="div">
          {project?.expBenefitRate !== undefined
          ? `${Number(project?.expBenefitRate).toFixed(2)} %`
          : `${Number(totalMargin).toFixed(2)} %`}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default CostSummary;
